import React from 'react'
import Navbar from "../inc/Navbar";
import ScrollToTop from "react-scroll-to-top";

import { Link } from "react-router-dom";
import "./Blog.css";

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import Balajisaree_grandopeing from "../images/Balaji Saree_Grand Opeing.jpeg";
import balajisaree from "../images/Most Grand Opeing Karimpur.jpeg";
import grandopeing_karimpur from "../images/Opening_Aparajita madam.jpeg";

import gppremiakrishnagar from "../images/gppremia krishnagar.jpg";
import gpremiagrandopening from "../images/Hero Premia.jpg";
import HeroPremiagrandopening from "../images/G.P Premia Showroom Grand Opening.jpg";
import premiakrishnanagar from "../images/Cake time G.P. PREMIA Krishnagar.jpg";

import MaryImmaculateSchoolAlumniAssociation from "../images/Mary Immaculate School Alumni Association.jpg";
import getannual_misaa from "../images/GET-ANNUAL programme.jpg";
import misaa_reunion from "../images/Misaa Re-union 2024.jpg";
import registerat_misaa from "../images/REGISTER at www.misaa.org.in.jpg"

import gettogether_mak from "../images/GET- TOGETHER 2024 mak.org.in Mountaineers’ Association of Krishnanagar.jpg";
import mak_team from "../images/MAK photo.jpg";

import Rupaecobrick from "../images/Rupa Eco Brick.jpg"

import Jewellersberhampore from "../images/Hon'ble Rajib Dhar with Tanmay Sarkar.jpg";
import mbdharberhampore from "../images/MB DHAR AND SON JEWELLERS.jpg";


function Blog() {

    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 1
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />
            <ScrollToTop smooth top="100" color="Gray" />
            <div className='websitedevelopkrishnagar'>
                <div className="album py-2">

                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Blog Page</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>


            <div className='blogcolor'>
                <div className="album py-2">

                    <div className="container">
                        <br />
                        <h1 className='single-line-text mb-0'><b>Blog</b> Page</h1>
                        <div className="row">
                            <div className="col-md-3">
                                <hr className='mb-2' />
                            </div>
                        </div>

                    </div>
                </div>

                <div className="album py-2">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-4">

                                <Carousel responsive={responsive}>

                                    <div className="card border mb-3 me-3" >

                                        <img className="card-img-top" src={Balajisaree_grandopeing} alt="Balajisaree_grandopeing" />

                                        <div className="card-body text">
                                            <center>
                                                <h6 style={{ color: "#0aaec6" }} className="card-title mb-0"><b>BALAJI SAREE</b></h6>
                                                <p style={{ color: "#072646" }} className="card-text"><small>Grand Opeing at Karimpur (New Bus Stand, Nadia)</small></p>
                                            </center>
                                            <div className="d-flex justify-content-center align-items-end mb-0">
                                                <a href='balajisaree'>
                                                    <button className='balajisaree mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                    </svg></button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card border mb-3 me-3" >

                                        <img className="card-img-top" src={balajisaree} alt="balajisaree" />

                                        <div className="card-body text">
                                            <center>
                                                <h6 style={{ color: "#0aaec6" }} className="card-title mb-0"><b>G.P. PREMIA Krishnagar</b></h6>
                                                <p style={{ color: "#072646" }} className="card-text"><small>Grand Opeing at Karimpur (New Bus Stand, Nadia)</small></p>
                                            </center>
                                            <div className="d-flex justify-content-center align-items-end mb-0">
                                                <a href='balajisaree'>
                                                    <button className='balajisaree mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                    </svg></button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>



                                    <div className="card border mb-3 me-3" >

                                        <img className="card-img-top" src={grandopeing_karimpur} alt="grandopeing_karimpur" />

                                        <div className="card-body text">
                                            <center>
                                                <h6 style={{ color: "#0aaec6" }} className="card-title mb-0"><b>BALAJI SAREE</b></h6>
                                                <p style={{ color: "#072646" }} className="card-text"><small>Grand Opeing at Karimpur (New Bus Stand, Nadia)</small></p>
                                            </center>
                                            <div className="d-flex justify-content-center align-items-end mb-0">
                                                <a href='balajisaree'>
                                                    <button className='balajisaree mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                    </svg></button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                </Carousel>


                            </div>
                            <div className="col-md-4">

                                <Carousel responsive={responsive}>

                                    <div className="card border mb-3 me-3" >

                                        <img className="card-img-top" src={gppremiakrishnagar} alt="gppremiakrishnagar Grand Opening" />

                                        <div className="card-body text">
                                            <center>
                                                <h6 style={{ color: "#0aaec6" }} className="card-title mb-0"><b>G.P PREMIA Krishnagar</b></h6>
                                                <p style={{ color: "#072646" }} className="card-text"><small>Grand Opening</small></p>
                                            </center>
                                            <div className="d-flex justify-content-center align-items-end mb-0">
                                                <a href='gppremia-krishnagar'>
                                                    <button className='balajisaree mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                    </svg></button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card border mb-3 me-3" >

                                        <img className="card-img-top" src={gpremiagrandopening} alt="pgpremiagrandopening" />

                                        <div className="card-body text">
                                            <center>
                                                <h6 style={{ color: "#0aaec6" }} className="card-title mb-0"><b>G.P PREMIA Krishnagar</b></h6>
                                                <p style={{ color: "#072646" }} className="card-text"><small>Grand Opening</small></p>
                                            </center>
                                            <div className="d-flex justify-content-center align-items-end mb-0">
                                                <a href='gppremia-krishnagar'>
                                                    <button className='balajisaree mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                    </svg></button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>



                                    <div className="card border mb-3 me-3" >
                                        <img className="card-img-top" src={HeroPremiagrandopening} alt="HeroPremia grand opening at Krishnage" />

                                        <div className="card-body text">
                                            <center>
                                                <h6 style={{ color: "#0aaec6" }} className="card-title mb-0"><b>G.P PREMIA Krishnagar</b></h6>
                                                <p style={{ color: "#072646" }} className="card-text"><small>Grand Opening</small></p>
                                            </center>
                                                                                        <div className="d-flex justify-content-center align-items-end mb-0">

                                             <a href='gppremia-krishnagar'>
                                                    <button className='balajisaree mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                    </svg></button>
                                                </a>
                                                </div>
                                        </div>
                                    </div>
                                    <div className="card border mb-3 me-3" >
                                        <img className="card-img-top" src={premiakrishnanagar} alt="premiakrishnanagar" />

                                        <div className="card-body text">
                                            <center>
                                                <h6 style={{ color: "#0aaec6" }} className="card-title mb-0"><b>G.P PREMIA Krishnagar</b></h6>
                                                <p style={{ color: "#072646" }} className="card-text"><small>Grand Opening</small></p>
                                            </center>
                                            <div className="d-flex justify-content-center align-items-end mb-0">
                                                <a href='gppremia-krishnagar'>
                                                    <button className='balajisaree mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                    </svg></button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </Carousel>

                            </div>
                            <div className="col-md-4">

                                <Carousel responsive={responsive}>

                                    <div className="card border mb-3 me-3" >

                                        <img className="card-img-top" src={MaryImmaculateSchoolAlumniAssociation} alt="MaryImmaculateSchoolAlumniAssociation" />

                                        <div className="card-body text">
                                            <center>
                                                <h6 style={{ color: "#0aaec6" }} className="card-title mb-0"><b>Mary Immaculate School Alumni Association</b></h6>
                                                <p style={{ color: "#072646" }} className="card-text"><small>Get Together Re-Union 2024</small></p>
                                            </center>
                                            <div className="d-flex justify-content-center align-items-end mb-0">
                                                <a href='misaa'>
                                                    <button className='balajisaree mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                    </svg></button>
                                                </a>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="card border mb-3 me-3" >

                                        <img className="card-img-top" src={misaa_reunion} alt="misaa_reunion" />

                                        <div className="card-body text">
                                            <center>
                                                <h6 style={{ color: "#0aaec6" }} className="card-title mb-0"><b>Mary Immaculate School Alumni Association</b></h6>
                                                <p style={{ color: "#072646" }} className="card-text"><small>Get Together Re-Union 2024</small></p>
                                            </center>

                                            <div className="d-flex justify-content-center align-items-end mb-0">
                                                <a href='misaa'>
                                                    <button className='balajisaree mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                    </svg></button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>



                                    <div className="card border mb-3 me-3" >

                                        <img className="card-img-top" src={getannual_misaa} alt="getannual_misaa" />

                                        <div className="card-body text">
                                            <center>
                                                <h6 style={{ color: "#0aaec6" }} className="card-title mb-0"><b>Mary Immaculate School Alumni Association</b></h6>
                                                <p style={{ color: "#072646" }} className="card-text"><small>Get Together Re-Union 2024</small></p>
                                            </center>
                                            <div className="d-flex justify-content-center align-items-end mb-0">
                                                <a href='misaa'>
                                                    <button className='balajisaree mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                    </svg></button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card border mb-3 me-3" >

                                        <img className="card-img-top" src={registerat_misaa} alt="register at MISAA Berhampore" />

                                        <div className="card-body text">
                                            <center>
                                                <h6 style={{ color: "#0aaec6" }} className="card-title mb-0"><b>Mary Immaculate School Alumni Association</b></h6>
                                                <p style={{ color: "#072646" }} className="card-text"><small>Get Together Re-Union 2024</small></p>
                                            </center>
                                            <div className="d-flex justify-content-center align-items-end mb-0">
                                                <a href='misaa'>
                                                    <button className='balajisaree mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                    </svg></button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </Carousel>

                            </div>

                            <div className="col-md-4">

                                <Carousel responsive={responsive}>

                                    <div className="card border mb-3 me-3" >

                                        <img className="card-img-top" src={gettogether_mak} alt="gettogether_mak" />

                                        <div className="card-body text">
                                            <center>
                                                <h6 style={{ color: "#0aaec6" }} className="card-title mb-0"><b>Mountaineers’ Association of Krishnanagar</b></h6>
                                                <p style={{ color: "#072646" }} className="card-text"><small>Get Together 2024</small></p>
                                            </center>
                                            <div className="d-flex justify-content-center align-items-end mb-0">
                                                <a href='mak'>
                                                    <button className='balajisaree mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                    </svg></button>
                                                </a>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="card border mb-3 me-3" >

                                        <img className="card-img-top" src={mak_team} alt="mak_team" />

                                        <div className="card-body text">
                                            <center>
                                                <h6 style={{ color: "#0aaec6" }} className="card-title mb-0"><b>Mountaineers’ Association of Krishnanagar</b></h6>
                                                <p style={{ color: "#072646" }} className="card-text"><small>Get Together 2024</small></p>
                                            </center>

                                            <div className="d-flex justify-content-center align-items-end mb-0">
                                                <a href='mak'>
                                                    <button className='balajisaree mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                    </svg></button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>





                                </Carousel>

                            </div>
                            <div className="col-md-4">

                                <Carousel responsive={responsive}>

                                    <div className="card border mb-3 me-3" >

                                        <img className="card-img-top" src={Rupaecobrick} alt="Rupa Eco Brick" />

                                        <div className="card-body text">
                                            <center>
                                                <h6 style={{ color: "#0aaec6" }} className="card-title mb-0"><b>Rupa Eco Brick</b></h6>
                                                <p style={{ color: "#072646" }} className="card-text"><small>Best Paver Block, Tiles, Brick Manufacture & Supplier in Berhampore, Murshidabad</small></p>
                                            </center>
                                            <div className="d-flex justify-content-center align-items-end mb-0">
                                                <a href='blog-rupaecobrick'>
                                                    <button className='balajisaree mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                    </svg></button>
                                                </a>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="card border mb-3 me-3" >

                                        <img className="card-img-top" src={Rupaecobrick} alt="Rupaecobrick" />

                                        <div className="card-body text">
                                            <center>
                                                <h6 style={{ color: "#0aaec6" }} className="card-title mb-0"><b>Rupa Eco Brick</b></h6>
                                                <p style={{ color: "#072646" }} className="card-text"><small>Best Paver Block, Tiles, Brick Manufacture & Supplier in Berhampore, Murshidabad</small></p>
                                            </center>

                                            <div className="d-flex justify-content-center align-items-end mb-0">
                                                <a href='blog-rupaecobrick'>
                                                    <button className='balajisaree mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                    </svg></button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>





                                </Carousel>

                            </div>

                            <div className="col-md-4">

                                <Carousel responsive={responsive}>

                                    <div className="card border mb-3 me-3" >

                                        <img className="card-img-top" src={Jewellersberhampore} alt="Jewellersberhampore" />

                                        <div className="card-body text">
                                            <center>
                                                <h6 style={{ color: "#0aaec6" }} className="card-title mb-0"><b>MB DHAR AND SON JEWELLERS</b></h6>
                                                <p style={{ color: "#072646" }} className="card-text"><small>Best Jewellers Showroom in Berhampore, Murshidabad</small></p>
                                            </center>
                                            <div className="d-flex justify-content-center align-items-end mb-0">
                                                <a href='mbdharandsonjewellers'>
                                                    <button className='balajisaree mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                    </svg></button>
                                                </a>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="card border mb-3 me-3" >

                                        <img className="card-img-top" src={mbdharberhampore} alt="mbdharberhampore" />

                                        <div className="card-body text">
                                            <center>
                                                <h6 style={{ color: "#0aaec6" }} className="card-title mb-0"><b>MB DHAR AND SON JEWELLERS</b></h6>
                                                <p style={{ color: "#072646" }} className="card-text"><small>Best Jewellers Showroom in Berhampore, Murshidabad</small></p>
                                            </center>

                                            <div className="d-flex justify-content-center align-items-end mb-0">
                                                <a href='mbdharandsonjewellers'>
                                                    <button className='balajisaree mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                    </svg></button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card border mb-3 me-3" >

                                        <img className="card-img-top" src={mbdharberhampore} alt="mbdharberhampore" />

                                        <div className="card-body text">
                                            <center>
                                                <h6 style={{ color: "#0aaec6" }} className="card-title mb-0"><b>MB DHAR AND SON JEWELLERS</b></h6>
                                                <p style={{ color: "#072646" }} className="card-text"><small>Best Jewellers Showroom in Berhampore, Murshidabad</small></p>
                                            </center>

                                            <div className="d-flex justify-content-center align-items-end mb-0">
                                                <a href='#'>
                                                    <button className='balajisaree mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                    </svg></button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>



                                </Carousel>

                            </div>
                        </div>
                    </div>

                </div>
                <br />
            </div>

        </div>
    )
}

export default Blog